import { FC } from 'react';
import { Icon } from 'Components/UI';
import { AiIconDefinition, aiIcons, AiIconName } from '../../Utils/icons';
import { colors } from '../../Utils/tokens';

export interface AiIconProps {
  name: AiIconName;
  /** Caixa do ícone; o glyph usa o tamanho calibrado em `aiIcons`. */
  box?: number;
  color?: string;
}

/** Ícone icomoon numa caixa fixa (o `Icon` padrão ocupa 24px e só muda o font-size). */
export const AiIcon: FC<AiIconProps> = ({ name, box, color }) => {
  const { glyph, size, color: defaultColor }: AiIconDefinition = aiIcons[name];
  const boxSize = box ?? Math.max(16, size);

  return (
    <Icon
      icon={glyph}
      customSize={size}
      customColor={color ?? defaultColor ?? colors.onSurfaceVariant}
      style={{ width: boxSize, height: boxSize, flexShrink: 0 }}
    />
  );
};
